import { render, staticRenderFns } from "./ArchiveCatalog.vue?vue&type=template&id=31ddacbb&"
import script from "./ArchiveCatalog.vue?vue&type=script&lang=js&"
export * from "./ArchiveCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports